<div class="form-group" [ngClass]="[classGroup]" [class.invalid]="!control.valid && !control.disabled && control.touched">
  <div [ngClass]="[classHeader]">
    <ng-content select="[control-label]"></ng-content>
    <ng-content select="[control-action-button]"></ng-content>
  </div>
  <ng-content select="[control-wrapper]"></ng-content>
  <ng-content select="[custom-error]"></ng-content>
  <app-control-errors
    [control]="control"
    [errors]="errors"
    [errorsOverrideParams]="errorsOverrideParams"
    [helper]="helper"
    [isShowHelper]="isShowHelper"
  ></app-control-errors>
</div>
